import { CaptionedNominalImage } from '@/components/controls';
import { useGroups, useUser, useUserInfo } from '@/hooks';
import { listGroupLabels } from '@/utils';
import { Settings as SettingsIcon } from '@mui/icons-material';
import {
  Box,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { addDays, format, startOfDay, subDays } from 'date-fns';

export function Notice({ notice, onSettingsClick }) {
  const {
    query: { data: user },
  } = useUser(notice.edited.username);
  const {
    query: {
      data: { briefingRole, ...userInfo },
    },
  } = useUserInfo();

  const {
    query: { data: groups },
  } = useGroups({ types: ['SECTOR', 'TEAM'] });
  const today = startOfDay(new Date());
  const bgcolor =
    notice.expiryDate > subDays(today, 3)
      ? 'success.main'
      : notice.expiryDate > addDays(today, 5)
        ? 'warning.main'
        : 'error.main';

  return (
    <Card variant="outlined">
      <Stack>
        <CardContent>
          <Stack
            direction="row"
            spacing={1}
            sx={{ justifyContent: 'space-between' }}
          >
            <Typography variant="caption" color="textSecondary" gutterBottom>
              {user
                ? `${user?.displayName} - ${format(new Date(notice.edited.time), 'dd/MM/yyyy HH:mm')}`
                : '-'}
            </Typography>
            <Typography variant="caption" color="textSecondary" gutterBottom>
              {!!notice && !!groups
                ? `${listGroupLabels('Group', notice.groupCodes, groups)}`
                : ''}
            </Typography>
          </Stack>
          <Typography
            variant="h6"
            align="center"
            gutterBottom
            sx={{ flexGrow: 1 }}
          >
            {notice.title}
          </Typography>
          <Box
            sx={{ '& img': { maxWidth: ['100%', '!important'] } }}
            dangerouslySetInnerHTML={{ __html: notice.contentHTML }}
          />
          <Stack direction="row" spacing={1} sx={{ overflowX: 'auto' }}>
            {notice.nominalIds?.map((nominalId) => (
              <CaptionedNominalImage key={nominalId} nominalId={nominalId} />
            ))}
          </Stack>
        </CardContent>
        <CardActions>
          <Tooltip title="Expires">
            <Stack
              direction="row"
              spacing={0.5}
              sx={{ px: 1, justifyItems: 'center' }}
            >
              <Box
                sx={{
                  bgcolor,
                  borderRadius: 8,
                  width: 16,
                  height: 16,
                }}
              />
              <Typography variant="caption" color="textSecondary">
                {notice.expiryDate
                  ? format(new Date(notice.expiryDate), 'dd/MM/yyyy')
                  : '-'}
              </Typography>
            </Stack>
          </Tooltip>
          <Box sx={{ flexGrow: 1 }} />
          {(briefingRole === 'ADMIN' ||
            (briefingRole === 'SUPERVISOR' &&
              notice.edited.username === userInfo.username)) && (
            <Tooltip title="Settings">
              <IconButton size="small" onClick={onSettingsClick}>
                <SettingsIcon />
              </IconButton>
            </Tooltip>
          )}
        </CardActions>
      </Stack>
    </Card>
  );
}
